(function() {

    var resizeTimer = null;
    var slickConfigration = {
        carousel1: { "dots": true, "arrows": false, "autoplay": true, "autoplaySpeed": 6000 },
        carousel2: { "dots": true, "arrows": false, "slidesToShow": 3, "slidesToScroll": 3, "responsive": [{ "breakpoint": 768, "settings": { "dots": false, "slidesToShow": 1, "slidesToScroll": 1 } }] },
        carousel3: { "dots": false, "arrows": false, "slidesToShow": 2, "slidesToScroll": 2, "responsive": [{ "breakpoint": 768, "settings": { "slidesToShow": 1, "slidesToScroll": 1 } }] }
    };
    var carousel = {
        init: function() {
            $(".sembcorp-carousel .sembcorp-carousel-wrapper").each(function() {
                var config = slickConfigration[$(this).data("slick")];
                var $carousel = $(this);

                if ($carousel.children().length > 1) {
                    $carousel.on("init", function() {
                        carousel.slideNavigate($carousel, $carousel.parents(".sembcorp-carousel"));

                        $carousel.find("img").on("load", function() {
                            // carousel.adaptiveHeight($carousel);
                        });
                    });
                    if ($(window).width() < 768) {
                        $(".hide-mobile").remove();
                    }
                    $carousel.slick(config);
                    $carousel.on("afterChange", function() {
                        // carousel.adaptiveHeight($carousel);
                    });
                }
            });

        },

        resize: function() {

            $(window).on("resize", function() {

                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function() {
                    $(".sembcorp-carousel .sembcorp-carousel-wrapper").each(function() {
                        var $carousel = $(this);
                        carousel.adaptiveHeight($carousel);
                    });
                }, 350);
            });
        },

        adaptiveHeight: function($carousel) {
            var maxHeight = 0;

            $carousel.find(".slick-active").each(function() {
                var $slickActive = $(this);

                if ($slickActive.outerHeight(true) > maxHeight) {
                    maxHeight = $slickActive.outerHeight(true);
                }
            });

            $carousel.find(".slick-list").css({
                "height": maxHeight
            });
        },

        slideNavigate: function($carousel, $container) {

            $container.find(".btn-prev").on("click", function() {
                $carousel.slick("slickPrev");
            });

            $container.find(".btn-next").on("click", function() {
                $carousel.slick("slickNext");
            });
        }
    };

    carousel.init();
    carousel.resize();

})();